import { render, staticRenderFns } from "./BannerV1LocalizationForm.vue?vue&type=template&id=305752b0&scoped=true&"
import script from "./BannerV1LocalizationForm.vue?vue&type=script&lang=js&"
export * from "./BannerV1LocalizationForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerV1LocalizationForm.vue?vue&type=style&index=0&id=305752b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305752b0",
  null
  
)

export default component.exports